/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_stddev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Std deviation`)
};

const es_st_stddev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desv. estándar`)
};

const de_st_stddev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardabweichung`)
};

const nl_st_stddev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standaardafwijking`)
};

const fr_st_stddev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écart-type`)
};

const it_st_stddev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deviazione standard`)
};

const pt_br2_st_stddev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desvio padrão`)
};

const pt_st_stddev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desvio-padrão`)
};

const ja_st_stddev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準偏差`)
};

const zh_st_stddev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准差`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_stddev = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_stddev(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_stddev", locale)
	if (locale === "en") return en_st_stddev(inputs)
	if (locale === "es") return es_st_stddev(inputs)
	if (locale === "de") return de_st_stddev(inputs)
	if (locale === "nl") return nl_st_stddev(inputs)
	if (locale === "fr") return fr_st_stddev(inputs)
	if (locale === "it") return it_st_stddev(inputs)
	if (locale === "pt-BR") return pt_br2_st_stddev(inputs)
	if (locale === "pt") return pt_st_stddev(inputs)
	if (locale === "ja") return ja_st_stddev(inputs)
	return zh_st_stddev(inputs)
};